module.exports = __webpack_public_path__ + "img/header-img-h5.1534d0af.png";